export const getColors = (type, score) => {
    switch (type) {
    case "csat":
        if (score >= 60) return "rgb(82, 196, 26)";
        if (score >= 30) return "rgb(234 179 8)";
        return "rgb(239 68 68)";
    default: // NPS
        if (score >= 60) return "rgb(82, 196, 26)";
        if (score >= 30) return "rgb(234 179 8)";
        return "rgb(239 68 68)";
    }
};
export const RATING_VALUE = [
    "Very unsatisfied",
    "Unsatisfied",
    "Neutral",
    "Satisfied",
    "Very satisfied"
];
export const defaultValues = {
    _id                       : "",
    name                      : "",
    survey_type               : "",
    additional_message        : "",
    question_message          : "How likely are you to recommend our service to others?",
    bad_rating_text           : "Not likely at all",
    good_rating_text          : "Extremely likely",
    enable_additional_comments: false,

    additional_comments: {
        promoter   : "What made your experience exceptional?",
        passive    : "What could we improve?",
        detractor  : "How can we make things right?",
        satisfied  : "What made your experience exceptional?",
        unsatisfied: "What could we improve?",
        neutral    : "How can we make things right?"
    },

    response_values: {
        very_satisfied  : "Very Satisfied",
        satisfied       : "Satisfied",
        neutral         : "Neutral",
        unsatisfied     : "Unsatisfied",
        very_unsatisfied: "Very Unsatisfied"
    },

    thank_you_messages: {
        promoter   : "Thank you for your fantastic feedback! We're thrilled you had a great experience.",
        passive    : "Thank you for your feedback. We appreciate your input and will work on improving.",
        detractor  : "We apologize for not meeting your expectations. Thank you for helping us improve.",
        satisfied  : "Thank you for your fantastic feedback! We're thrilled you had a great experience.",
        neutral    : "Thank you for your feedback. We appreciate your input and will work on improving.",
        unsatisfied: "We apologize for not meeting your expectations. Thank you for helping us improve."
    }
};

export const ADDITIONAL_COMMENTS = {
    csat:
    [
        { title: "Satisfied", id: "additional_comments.satisfied" },
        { title: "Neutral", id: "additional_comments.neutral" },
        { title: "Unsatisfied", id: "additional_comments.unsatisfied" }
    ],
    nps: [
        {
            title      : "Promoters",
            id         : "additional_comments.promoter",
            placeholder: "Question for promoters (scores 9-10)"
        },
        {
            title      : "Passives",
            id         : "additional_comments.passive",
            placeholder: "Question for passives (scores 7-8)"
        },
        {
            title      : "Detractors",
            id         : "additional_comments.detractor",
            placeholder: "Question for detractors (scores 0-6)"
        }
    ]
};

export const THANK_YOU_MESSAGES = {
    
    csat: [
        {
            title      : "Satisfied",
            id         : "thank_you_messages.satisfied",
            placeholder: "Thank you message for satisfied users"
        },
        {
            title      : "Neutral",
            id         : "thank_you_messages.neutral",
            placeholder: "Thank you message for neutral users"
        },
        {
            title      : "Unsatisfied",
            id         : "thank_you_messages.unsatisfied",
            placeholder: "Thank you message for unsatisfied users"
        }
    ],
    nps: [
        {
            title      : "Promoters",
            id         : "thank_you_messages.promoter",
            placeholder: "Thank you message for promoters (scores 9-10)"
        },
        {
            title      : "Passives",
            id         : "thank_you_messages.passive",
            placeholder: "Thank you message for passives (scores 7-8)"
        },
        {
            title      : "Detractors",
            id         : "thank_you_messages.detractor",
            placeholder: "Thank you message for detractors (scores 0-6)"
        }
    ] };

export const CSAT_RESPONSE_VALUES = [
    {
        title      : "Very Satisfied",
        id         : "response_values.very_satisfied",
        placeholder: "Very Satisfied"
    },
    {
        title      : "Satisfied",
        id         : "response_values.satisfied",
        placeholder: "Satisfied"
    },
    {
        title      : "Neutral",
        id         : "response_values.neutral",
        placeholder: "Neutral"
    },
    {
        title      : "Unsatisfied",
        id         : "response_values.unsatisfied",
        placeholder: "Unsatisfied"
    },
    {
        title      : "Very Unsatisfied",
        id         : "response_values.very_unsatisfied",
        placeholder: "Very Unsatisfied"
    }
];

export const RATING_LABELS = [
    { title: "Bad Rating", id: "bad_rating_text", placeholder: "Label for bad rating" },
    { title: "Good Rating", id: "good_rating_text", placeholder: "Label for good rating" }
];